export default "__VITE_ASSET__5SzBDnj$__"